import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { SITE } from "@/data/site";

/**
 * Floating click-to-call pill for phones. Appears once the visitor scrolls
 * past the hero and steps aside while the Quote section (which has its own
 * floating estimate bar) is on screen.
 */
export default function MobileCallButton() {
  const [pastHero, setPastHero] = useState(false);
  const [quoteVisible, setQuoteVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setPastHero(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const quote = document.getElementById("quote");
    if (!quote) return undefined;
    const io = new IntersectionObserver(
      ([e]) => setQuoteVisible(e.isIntersecting),
      { threshold: 0.05 }
    );
    io.observe(quote);
    return () => io.disconnect();
  }, []);

  const show = pastHero && !quoteVisible;

  return (
    <a
      href={`tel:${SITE.phoneRaw}`}
      data-testid="mobile-call-button"
      aria-label={`Call ${SITE.phone}`}
      aria-hidden={!show}
      className={`md:hidden fixed bottom-4 right-4 z-40 flex items-center gap-2 pl-4 pr-5 py-3 bg-[#D4AF37] text-black shadow-[0_10px_30px_rgba(212,175,55,0.35)] transition-all duration-400 ${
        show
          ? "translate-y-0 opacity-100"
          : "translate-y-24 opacity-0 pointer-events-none"
      }`}
    >
      <span className="relative flex w-8 h-8 items-center justify-center rounded-full bg-black/10">
        <span className="absolute inset-0 rounded-full bg-black/10 animate-ping" />
        <Phone className="w-4 h-4 relative" />
      </span>
      <span className="text-[11px] font-semibold uppercase tracking-[0.18em]">
        Call Warren
      </span>
    </a>
  );
}
